export default __webpack_public_path__ + "static/media/Logo.57b90870.svg";